module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/2-2-1-a080448b979b08f549b0d7388d81b5ee.png";